import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


import Orders from './orders';
import Insights from './Insights';
import Statement from './statements';
const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>


      <Route path={`${match.url}/orders`} component={Orders} />
      <Route path={`${match.url}/insights`} component={Insights} />
      <Route path={`${match.url}/statement`} component={Statement} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
